
require('./libs/details-pollyfill.js');
require('./modules/_clear-umb-forms.js');
require('./modules/address-lookup.js');
require('./modules/updateURLParameter.js');
require('./modules/_burger-menu.js');
require('./modules/_mobile-search-expander.js');
require('./modules/_main-nav.js');
require('./modules/_collapse-disable.js');
require('./modules/_load-more.js');
require('./modules/_deferred_image_load.js');
require('./modules/_slide-animation-triggers.js');
require('./modules/_disabled-elements.js');
require('./modules/_browse-aloud-remote.js');
require('./modules/_news-filters.js');
require('./modules/_twitter-timeline.js');
require('./modules/_double-back-button.js');



var rev = '0110';




// font face observer
function SetUpFontFaceObserver() {

    var fontA = new FontFaceObserver('Futura Std Book');
    var fontB = new FontFaceObserver('Futura Std Bold');
    var fontC = new FontFaceObserver('Futura Std Medium');

    if (document.documentElement.classList.contains('fonts-loaded')) {
        // fonts should be in cache
    } else {

        Promise.all([fontA.load(), fontB.load(), fontC.load()]).then(function () {
            document.documentElement.className += " fonts-loaded";
            // drop a cookie indicating that fonts should now be available from cache
            document.cookie = "fonts-loaded=true";
        });
    }
}

window.overrideBannerText = function(txt) {

    var el = document.querySelector('h1.banner__heading');

    if (el != null) {
        el.innerText = txt;
    }
}

window.disableSubmitButtonOnClick = function() {
    var btn = document.querySelector('.umbraco-forms-form .btn');

    if (btn) {
        btn.addEventListener('click', function () {

            // if the form is valid, disable the button to prevent double submission

            // var errors = document.querySelectorAll('.umbraco-forms-form .field-validation-error');
            var frm = $(this).closest("form");

            frm.validate();

            var isFormValid = frm.valid();

            if (isFormValid) {
                btn.disabled = true;
                frm.submit();
            }

            return true;
        })
    }
}


// detect clicks on FAQ anchors and set properties on the linked element...
// this is to auto-expand faq details/summary elements
// cannot rely on hashchange event as LeO picked up on someone clicking the same link multiple times, not changing the hash
window.monitorFAQLinks = function () {
    const faqLinks = document.querySelectorAll('a[href*="#FAQAnchor"]');

    faqLinks.forEach(function (link) {
        link.addEventListener('click', function (e) {

            const href = link.getAttribute('href');
            const hashPart = href.split('#')[1]

            if (hashPart != '') {
                var newID = hashPart.replace("FAQAnchor", "FAQLabel");
                var el = document.querySelector('#' + newID);
                if (el) {

                    //el.scrollIntoView();
                    el.parentElement.open = true;
                    el.setAttribute('aria-expanded', true);
                    el.focus();
                    // reset the hash so that this will fire again if the user clicks the same link again
                    // window.location.hash = newID;
                } else {
                    console.log('unable to locate an element with ID ' + newID);
                }
            }
        })
    });

    // update the URL has to reflect expanded faq items

    var summaryElements = document.querySelectorAll('summary');

    // find all of the summary elements on the page and update the url hash id of the element when it is expanded, or remove from the url when it is closed
    summaryElements.forEach(function (summary) {

        summary.addEventListener('click', function (e) {
            var id = summary.getAttribute('id');

            if (id != null && id != '') {
                if (summary.parentElement.open) {
                    //window.location.hash = '';
                    history.pushState("", document.title, window.location.pathname);
                } else {
                    //window.location.hash = id;
                    history.pushState("", document.title, window.location.pathname + '#' + id);
                }
            }
        });
    });

    window.addEventListener("popstate", (event) => {
        
        // if there is a hash in the url, expand the relevant faq item, or close any that are open
        if (window.location.hash) {
            var hash = window.location.hash;
            var newID = hash.replace("FAQAnchor", "FAQLabel");

            var el = document.querySelector(newID);

            if (el) {
                el.parentElement.open = true;
                el.setAttribute('aria-expanded', true);
                el.focus();
            }
        } else {
            // find and close any open faq items

            var openItems = document.querySelectorAll('details[open]');
            openItems.forEach(function (item) {
                item.open = false;
            });
        }
    });

    // if the page url contains a hash, expand the relevant faq item
    if (window.location.hash) {
        var hash = window.location.hash;
        var newID = hash.replace("FAQAnchor", "FAQLabel");

        var el = document.querySelector(newID);

        if (el) {
            el.parentElement.open = true;
            el.setAttribute('aria-expanded', true);
            el.focus();
        }
    }
}


if (document.readyState !== 'loading') {
    window.disableSubmitButtonOnClick();
    window.monitorFAQLinks();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        window.disableSubmitButtonOnClick();
        window.monitorFAQLinks();
    });
}


/// defferred script load
/// @url {string} - the url of the script to be loaded
/// @obj {object} - and instance of an object which can be used to determine if the script has already been loaded
/// @success {method} - callback on script load
(function () {
    function getScript(url, success) {

        var script = document.createElement('script');
        script.src = url;
        var head = document.getElementsByTagName('head')[0],
            done = false;
        script.onload = script.onreadystatechange = function () {
            if (!done && (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete')) {
                done = true;
                if (success && success instanceof Function) {
                    success();
                }
                script.onload = script.onreadystatechange = null;
                head.removeChild(script);
            }
        };
        head.appendChild(script);
    }

    // font face loader
    getScript('/js/fontfaceobserver.min.js?rev=' + rev, function () {
        SetUpFontFaceObserver();
    })

    // jquery
    getScript('https://code.jquery.com/jquery-3.5.1.min.js', function () {
        // execure any jquery code here

        // bootstrap js - dependency on jquery
        getScript('https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/js/bootstrap.min.js')


        getScript('https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.28.0/moment.min.js', function () { });


        // jquery validate - dependency on jquery
        getScript('https://cdnjs.cloudflare.com/ajax/libs/jquery-validate/1.15.0/jquery.validate.min.js', function () {

            // jquery validate unobtrusive - dependency on jquery validate
            getScript('https://cdnjs.cloudflare.com/ajax/libs/jquery-validation-unobtrusive/3.2.6/jquery.validate.unobtrusive.min.js', function () {

                // Umbraco Forms - dependency on jquery validate and validate unob
                //getScript('/App_Plugins/UmbracoForms/Assets/Themes/Default/umbracoforms.js?rev=' + rev);

                // replace the unob validate date method with something that supports en-GB date formats
                jQuery.validator.methods.date = function (value, element) {
                    var dateRegex = /^(0?[1-9]\/|[12]\d\/|3[01]\/){2}(19|20)\d\d$/;
                    return this.optional(element) || dateRegex.test(value);
                };

                // custom validation
                getScript('/js/leo.site.custom-validation.min.js?rev=20250911' + rev, function () { });
            })

        })

        // jquery unobtrusive
        getScript('/Scripts/jquery.unobtrusive-ajax.min.js');

        // lazysizes - dependancy on jquery
        getScript('/js/lazysizes.min.js')
    })


    // twitter
    getScript('https://platform.twitter.com/widgets.js')

    // Modernizr Clippath tests
    getScript('/js/src/libs/modernizr.clippath.min.js?rev=' + rev)

})();

function initTextareaCounterInForms() {

    if (window.jQuery && window.jQuery.fn.characterCounter) {

        var form = $('.form-group');

        if (form) {

            $('[data-char-limit]').characterCounter({
                remainText: 'Characters remaining',
                tooManyText: 'Characters too many',
                remainTextCY: 'Nodau ar ôl',
                //remainTextCY: "nodau sy'n weddill",
                tooManyTextCY: 'Yn ormod o nodau'
            });
        }
    }
    else {
        window.setTimeout(initTextareaCounterInForms, 500);
    }
}
window.setTimeout(initTextareaCounterInForms, 500);